import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext.jsx";
import axios from "axios";
import { Link } from "react-router-dom";

const baseURL = import.meta.env.VITE_API_URL;

const HomePage = ({ dataLogin }) => {

  // console.log("home", dataLogin.Role);

  const { authData } = useAuth();
  const [businessNames, setBusinessNames] = useState({});

  useEffect(() => {
    if (authData) {
      const fetchBusinessNames = async () => {
        const businessAuthorities = authData.BusinessAuthority.split(",");
        const businessCodes = businessAuthorities
          .slice(0, 7)
          .join("&BusinessCode=");
        const response = await axios.get(
          `${baseURL}/get/masterbusiness?BusinessCode=${businessCodes}`
        );
        const businessNamesObj = response.data.reduce((acc, item) => {
          acc[item.BusinessCode] = item.BusinessName;
          return acc;
        }, {});
        setBusinessNames(() => ({ ...businessNamesObj }));
      };
      fetchBusinessNames();
    }
  }, [authData]);

  if (!authData) {
    return <h1 className="loading">Loading...</h1>;
  }

  const businessAuthorities = authData.BusinessAuthority.split(",");
  const branchAuthorities = authData.BranchAuthority.split(",").map((item) =>
    item.trim()
  );

  localStorage.setItem("branchAuthorities", JSON.stringify(branchAuthorities));
  const isAdmin = authData.Role?.trim().toLowerCase() !== "user";

  return (
    <div className="min-h-screen bg-gray-100 pt-20 px-5">
      <div className="max-w-7xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h1 className="welcome-message text-2xl font-semibold text-gray-800 mb-6">
          Welcome, {authData.UserName}!
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {businessAuthorities.slice(0, 7).map((businessCode, index) => (
            <Link
              key={index}
              to="/reports"
              onClick={() => {
                localStorage.setItem("businessCode", businessCode);
                localStorage.setItem(
                  "businessName",
                  businessNames[businessCode]
                );
                localStorage.setItem("branchAuthorities", branchAuthorities);
                localStorage.setItem("username", authData.UserName);
                localStorage.setItem("role", authData.Role);
              }}
            >
              <div className="business-card p-4 rounded-lg bg-blue-100 shadow-md hover:shadow-lg transition-shadow duration-200">
                <h2 className="business-code text-lg font-medium text-blue-600">
                  {Object.keys(businessNames).includes(businessCode) && (
                    <img
                      src={`/img/${businessNames[businessCode]}.png`}
                      alt={businessNames[businessCode]}
                      className="w-18 h-20 mr-2"
                    />
                  )}
                  {Object.keys(businessNames).includes(businessCode)
                    ? businessNames[businessCode]
                    : businessCode}
                </h2>
              </div>
            </Link>
          ))}
          {isAdmin && ( // Add this conditional statement to show the "Add Account" card only to admins
            <Link
              to="/register"
              onClick={() => {
                localStorage.setItem(
                  "businessAuthorities",
                  businessAuthorities
                );
                localStorage.setItem("branchAuthorities", branchAuthorities);
                localStorage.setItem("username", authData.UserName);
              }}
            >
              <div className="business-card p-4 rounded-lg bg-blue-100 shadow-md hover:shadow-lg transition-shadow duration-200">
                <h2 className="business-code text-lg font-medium text-blue-600">
                  <img
                    src={`/img/register.png`}
                    alt="logo register"
                    className="w-18 h-20 mr-2"
                  />
                  Add Account
                </h2>
              </div>
            </Link>
          )}
        </div>
      </div>
      <style jsx>{`
        .min-h-screen {
          min-height: 100vh;
        }
        .welcome-message {
          color: #333;
        }
        .business-card {
          transition: transform 0.2s;
        }
        .business-card:hover {
          transform: translateY(-2px);
        }
        .business-code {
          font-size: 18px;
          color: #1d4ed8; /* Tailwind blue-600 */
        }
      `}</style>
    </div>
  );
};

export default HomePage;
